import React, {useEffect, useState} from "react";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import {prepareBuffer} from "../../util/Buffer";
import {Avatar, Button, Menu, MenuItem, Tooltip, Typography} from "@mui/material";
import {Black, Blue3, Grey17, Grey3, Grey5, Grey6} from "../../theme/styles";
import {makeEnterpriseComponent} from "../../util/utility";
import css_buttons from "../../components/Common/css/CCButton.module.scss";
import {AddCircle, Delete} from "@mui/icons-material";
import AdminPrivilegeConstraintEmployeeFormApplet from "../../eoec/applet/impl/Administration/AdminPrivilegeConstraintEmployeeFormApplet";
import css_self from "../Navigation/css/NavBar.module.scss";
import MemoryContext from "../../util/MemoryContext";
import EventBus from "../../util/EventBus";
import {hasPrivilege, SessionContext} from "../../util/SessionContext";


export default function PermissionConfiguration(props: any) {
    const [adminPrivilegeEnterpriseComponent] = useState(makeEnterpriseComponent("AdminPrivilege"));
    const [adminPrivilegeConstraintEnterpriseComponent] = useState(makeEnterpriseComponent("AdminPrivilegeConstraint"));
    const [adminPrivilegeBuffer, setAdminPrivilegeBuffer] = React.useState<Map<string, any>>(new Map<string, any>());
    const [showAddConstraint, setShowAddConstraint] = React.useState(false);
    const [showDeleteConstraint, setShowDeleteConstraint] = React.useState(false);
    const [showAddConstraintMenu, setShowAddConstraintMenu] = React.useState<EventTarget & HTMLButtonElement | null>(null);

    let sessionContext = new SessionContext();

    function enterpriseComponentLoadCompletedListener(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec)
        setAdminPrivilegeBuffer(b[0]);
    }

    function enterpriseComponentValueChanged(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec);
        setAdminPrivilegeBuffer(b[0]);
    }

    function enterpriseComponentUpdateRollbackCompleted(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec);
        b = b.slice(ec.getRecordPointer(), ec.getRecordPointer() + 1);
        setAdminPrivilegeBuffer(b[0]);
    }

    function enterpriseComponentInvalidateListener(ec: EnterpriseComponent) {
        adminPrivilegeEnterpriseComponent.newQuery();
        adminPrivilegeEnterpriseComponent.setAttributeValue("Name", props.name);
        adminPrivilegeEnterpriseComponent.setAttributeValue("ParentUSID", props.projectPlanBuffer.get("USID"));
        adminPrivilegeEnterpriseComponent.executeQuery(1, 1000);
    }

    useEffect(() => {
        adminPrivilegeEnterpriseComponent.newQuery();
        adminPrivilegeEnterpriseComponent.setAttributeValue("Name", props.name);
        adminPrivilegeEnterpriseComponent.setAttributeValue("ParentUSID", props.projectPlanBuffer.get("USID"));
        adminPrivilegeEnterpriseComponent.executeQuery(1, 1000);

        adminPrivilegeEnterpriseComponent.addInvalidListener(enterpriseComponentInvalidateListener);
        adminPrivilegeEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        adminPrivilegeEnterpriseComponent.addValueChangedListener(enterpriseComponentValueChanged);
        adminPrivilegeEnterpriseComponent.addUpdateRollbackCompletedListener(enterpriseComponentUpdateRollbackCompleted);

        EventBus.components.addListener("admin-privilege-constraint-form-applet-save", onCancelHandler);
        EventBus.components.addListener("admin-privilege-constraint-form-applet-cancel", onCancelHandler);

        return () => {
            EventBus.components.removeListener("admin-privilege-constraint-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("admin-privilege-constraint-form-applet-cancel", onCancelHandler);

            adminPrivilegeEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
            adminPrivilegeEnterpriseComponent.removeValueChangedListener(enterpriseComponentValueChanged);
            adminPrivilegeEnterpriseComponent.removeUpdateRollbackCompletedListener(enterpriseComponentUpdateRollbackCompleted);
        }

    }, [adminPrivilegeEnterpriseComponent]);

    function stringAvatar(name: string) {
        return name
            .split(" ")
            .map(word => word[0])
            .join("")
            .substring(0, 2);
    }

    function onCancelHandler() {
        setShowAddConstraint(false);
        setShowDeleteConstraint(false);

        adminPrivilegeEnterpriseComponent.invalidate()
    }

    function renderPrivilege() {
        if (adminPrivilegeBuffer && adminPrivilegeBuffer.get("ListOfGroup") === undefined) {
            return null;
        }

        return (
            <>
                {showAddConstraint ? <AdminPrivilegeConstraintEmployeeFormApplet enterpriseComponent={adminPrivilegeConstraintEnterpriseComponent} defaultAction={"New"}/> : null}
                {showDeleteConstraint ? <AdminPrivilegeConstraintEmployeeFormApplet enterpriseComponent={adminPrivilegeConstraintEnterpriseComponent} defaultAction={"Delete"}/> : null}
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "#FFFFFF", marginTop: "30px", borderBottom: "1px solid #D8DDE4"}}>
                    <Typography style={{fontSize: 20, fontWeight: 500, color: "#000000"}}>{adminPrivilegeBuffer.get("Name")}</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "column", backgroundColor: Grey3, border: "1px solid #7B8291", borderBottom: "0px", borderTopLeftRadius: "10px", borderTopRightRadius: "10px", borderBottomLeftRadius: "0px", borderBottomRightRadius: "0px", marginTop: "20px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", borderBottom: "1px solid #7B8291"}}>
                        <div style={{width: "410px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>Groups</Typography></div>
                        <div style={{width: "5px"}}><Typography style={{fontSize: 26, fontWeight: 500, color: Grey6, marginTop: "0px"}}>|</Typography></div>
                        <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>Group Membership</Typography></div>
                    </div>
                    {adminPrivilegeBuffer.get("ListOfGroup")["Group"].map((group: any, index: number) => (
                        <div key={index} style={{display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3"}}>
                            <div style={{display: "flex", flexDirection: "row"}}>
                                <div style={{marginTop: "10px", marginBottom: "10px", width: "410px"}}>
                                    <Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px", textOverflow: "ellipsis", overflow: "hidden"}}>{group["Name"]}</Typography>
                                </div>
                                <div style={{width: "300px", display: "flex", flexDirection: "column", marginTop: "5px"}}>
                                    {group["ListOfEmployee"]["Employee"].length === 0 ? (
                                         <div style={{display: "flex", flexDirection: "row"}}>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Grey5, margin: "15px 0 8px 10px"}}>No assigned users</Typography></div>
                                        </div>
                                    ): null}
                                    {group["ListOfEmployee"]["Employee"].map((employee: any) => (
                                        <div key={employee.USID} style={{display: "flex", flexDirection: "row"}}>
                                            <div style={{fontSize: 14, fontWeight: 500, color: Black, margin: "3px 0 0 10px"}}>
                                                <Avatar sx={{bgcolor: Blue3, width: 25, height: 25, fontSize: "12px"}}>{stringAvatar(employee.UserName)}</Avatar>
                                            </div>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "5px 0 8px 10px", textWrap: "nowrap"}}>{employee.UserName}</Typography></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div style={{display: "flex", flexDirection: "column", backgroundColor: Grey3, border: "1px solid #7B8291", borderBottom: "1px", marginTop: "0px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "transparent", borderBottom: "1px solid #7B8291"}}>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            <div style={{width: "410px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>Constraints</Typography></div>
                            <div style={{width: "5px"}}><Typography style={{fontSize: 26, fontWeight: 500, color: Grey6, marginTop: "0px"}}>|</Typography></div>
                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>Impact</Typography></div>
                        </div>
                        <div style={{padding: "6px 0 0 0"}}>
                            <Tooltip title={props.projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") !== sessionContext.getEmployeeUSID() && !hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION") ? "Only the Primary User (" + props.projectPlanBuffer.get("PrimaryPositionPrimaryUserName") + ") of the Primary Position (" + props.projectPlanBuffer.get("PrimaryPositionName") + ") can add constraints for this project." : 'Add Constraint'}>
                                <Button className={css_buttons.transparentStandardButton} style={{cursor: "pointer", height: "30px"}} size="small" onClick={(event) => {
                                    if (props.projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION")) {
                                        setShowAddConstraintMenu(event.currentTarget)}
                                    }
                                }
                                startIcon={<AddCircle sx={{width: "25px", height: "25px", color: (props.projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") !== sessionContext.getEmployeeUSID() && !hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION")) ? "#F1C40F" : "#1498D8"}}/>}/>
                            </Tooltip>
                            {showAddConstraintMenu ? (
                                <Menu anchorEl={showAddConstraintMenu}
                                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                      transformOrigin={{vertical: -5, horizontal: "center"}}
                                      open={true}
                                      onClose={() => setShowAddConstraintMenu(null)}
                                      TransitionProps={{
                                          onExited: () => setShowAddConstraintMenu(null),
                                      }}
                                      MenuListProps={{
                                          ...{"data-cc-component": "NavMenu"},
                                          disablePadding: true,
                                          style: {"minWidth": "200px"},
                                      }}
                                >
                                    <MenuItem key={"1"} className={css_self.Standard} onClick={() => {
                                        setShowAddConstraintMenu(null);
                                        setShowAddConstraint(true);
                                        // @ts-ignore
                                        MemoryContext.components["AdminPrivilege-AdminPrivilegeUSID"] = adminPrivilegeBuffer.get("USID")
                                        // @ts-ignore
                                        MemoryContext.components["AdminPrivilege-ParentUSID"] = props.projectPlanBuffer.get("USID")
                                        // @ts-ignore
                                        MemoryContext.components["AdminPrivilege-Type"] = "DENY_EMPLOYEE"
                                    }}>
                                        <Typography component="div" style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Employee Constraint</Typography>
                                    </MenuItem>
                                </Menu>
                                ) : null}
                        </div>
                    </div>
                    {adminPrivilegeBuffer.get("ListOfAdminPrivilegeConstraint")["AdminPrivilegeConstraint"].map((element: any, index: number) => {
                        if (element.Type === "DENY_EMPLOYEE") {
                            return (
                                <div key={index} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "#FFFFFF", borderBottom: "1px solid #D8DDE4", width: "100%"}}>
                                    <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
                                        <div style={{marginTop: "5px", marginBottom: "5px", minWidth: "410px"}}>
                                            <Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "5px 0 5px 10px", textOverflow: "ellipsis", overflow: "hidden"}}>{element.Name} ({element.Type})</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", marginTop: "5px", width: "100%"}}>
                                            <div key={"test"} style={{display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%"}}>
                                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                                                    <div style={{fontSize: 14, fontWeight: 500, color: Black, margin: "3px 0 0 10px"}}>
                                                        <Avatar sx={{bgcolor: Blue3, width: 25, height: 25, fontSize: "12px"}}>{stringAvatar(element.EmployeeName)}</Avatar>
                                                    </div>
                                                    <div style={{width: "100%"}}><Typography style={{fontSize: 14, fontWeight: 400, color: Black, margin: "5px 0 8px 10px"}}><b>{element.EmployeeName}</b> will be denied the {adminPrivilegeBuffer.get("Name")} privilege for this plan.</Typography></div>
                                                </div>
                                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", margin: "auto 0 auto 0"}}>
                                                    <Tooltip title={props.projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") !== sessionContext.getEmployeeUSID() && !hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION") ? "Only the Primary User (" + props.projectPlanBuffer.get("PrimaryPositionPrimaryUserName") + ") of the Primary Position (" + props.projectPlanBuffer.get("PrimaryPositionName") + ") can delete a constraint for this project." : 'Delete Constraint'}>
                                                        <Button className={css_buttons.transparentStandardButton} style={{cursor: "pointer", height: "30px"}} size="small" onClick={() => {
                                                            if (props.projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION")) {
                                                                setShowDeleteConstraint(true);
                                                                // @ts-ignore
                                                                MemoryContext.components["AdminPrivilege-AdminPrivilegeUSID"] = adminPrivilegeBuffer.get("USID")
                                                                // @ts-ignore
                                                                MemoryContext.components["AdminPrivilege-AdminPrivilegeConstraintUSID"] = element.USID
                                                            }
                                                        }} startIcon={<Delete sx={{color: (props.projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") !== sessionContext.getEmployeeUSID() && !hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION")) ? "#F1C40F" : "#1498D8", width: "25px", height: "25px"}}/>}/>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    })}
                </div>
            </>
        )
    }
    return (
        <>
            {renderPrivilege()}
        </>
    )
}
